import { Injectable } from "@angular/core";
import { BaseCrudService } from "./base-crud.service";
import { ILabel, ILabelImport, ILabelExport, Label } from "@schema/label";
import { ApiService } from "@core/service/api.service";
import { ContextService } from "@core/service/context.service";
import { IHttpRequestOptions, IHttpResponse } from "@schema/http";
import { Observable } from "rxjs";
import { environment as env } from "@env";

@Injectable({
  providedIn: "root"
})
export class LabelService extends BaseCrudService<ILabel, ILabelImport, ILabelExport> {

  readonly baseUri = `${env.api.clientHost}`;

  protected endpoint: string;
  protected readonly apiVersion = "2020-02-01";

  constructor(
    _apiService: ApiService,
    _context: ContextService,
  ) {
    super(_apiService);

    _context.property$.subscribe((property) => {
      this.endpoint = `${this.baseUri}/${this.apiVersion}/property/${property.id}/label`;
    });
  }

  /**
   * List all labels
   */
  public all(options?: IHttpRequestOptions): Observable<IHttpResponse<ILabel[]>> {
    return this._all(`${this.endpoint}/list`, options);
  }

  /**
   * Return a page entity from JSON
   */
  protected _deserializeEntity(json: ILabelImport): ILabel {
    return new Label(json);
  }
}
